import { useTranslation } from "react-i18next";

export function AquireTest() {
  const { t } = useTranslation();

  return (
    <section id="find_pharmacy">
      <h2 className="pb-8 pt-12">{t("Test erwerben")}</h2>
      <ol className="cabo flex flex-col justify-center gap-12 rounded-xl bg-white p-8">
        <li className="grid gap-1">
          <h3>{t("Besuchen Sie Ihre Apotheke und fragen Sie nach CaboCheck.")}</h3>
          <p>
            {t(
              "Bei jedem Test erhalten Sie ein Infoblatt mit Ihrem persönlichen Test QR-Code (CaboCheck-ID), über den Sie das Testergebnis abrufen können.",
            )}
          </p>
        </li>
        <li className="grid gap-1">
          <h3>{t("Testdurchführung vor Ort oder zu einem späteren Zeitpunkt")}</h3>
          <p>
            {t(
              "Vorbeikommen und in den Finger pieksen lassen. Wir nehmen Ihnen Blut aus der Fingerkuppe und schicken Ihre Blutprobe an ein medizinisches Facharztlabor bei CaboLab bzw. werten sie direkt bei uns vor Ort bei CaboPoc aus. Trinken Sie vorher ausreichend Wasser (300ml).",
            )}
          </p>
        </li>
        <li className="grid gap-1">
          <h3>{t("Schnelle und zuverlässige Ergebnisse")}</h3>
          <p>
            {t(
              "Sie erhalten nach wenigen Minuten (CaboPoc) bzw. wenigen Tagen (CaboLab) eine Mail und können Ihre Ergebnisse bei uns abholen und besprechen oder selbst online abrufen. Die Ergebnisse werden mit einer Ampel dargestellt. Wenn die Ampel bei Ihnen auf Rot oder Gelb steht, können Sie uns – wenn Sie mögen – die Ergebnisse freigeben. Wir schauen uns dann die Ergebnisse an und beraten Sie, was Sie jetzt idealerweise tun sollten.",
            )}
          </p>
        </li>
      </ol>
    </section>
  );
}
